import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { Clock } from 'lucide-react';

export default function SessionTimeoutDialog() {
  const navigate = useNavigate();
  const { sessionExpired, clearAuth, setSessionExpired } = useAuthStore();

  if (!sessionExpired) return null;

  const handleLogin = () => {
    clearAuth();
    setSessionExpired(false);
    navigate('/login');
  };

  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity" />

        {/* Dialog */}
        <div className="relative w-full max-w-md rounded-lg bg-white shadow-2xl">
          {/* Header */}
          <div className="flex items-center gap-3 rounded-t-lg bg-amber-500 px-6 py-4">
            <Clock className="h-6 w-6 text-white" />
            <h3 className="text-lg font-semibold text-white">Session Expired</h3>
          </div>

          {/* Content */}
          <div className="px-6 py-6">
            <p className="text-gray-700 text-center">
              Your session has timed out due to inactivity. Please log in again to continue.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-center rounded-b-lg bg-gray-50 px-6 py-4">
            <button
              onClick={handleLogin}
              className="px-6 py-2 bg-amber-500 text-white font-medium rounded-lg hover:bg-amber-600 transition-colors"
            >
              Log In Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
